import { createOutlineIcon } from "../createIcon";

export const CopyRightOutlineIcon = createOutlineIcon(
  <>
    <path d="M15.9688 10.0625H17.6563C18.1222 10.0625 18.5 10.4403 18.5 10.9062L18.5 16.5C18.5 17.6046 17.6046 18.5 16.5 18.5L10.9063 18.5C10.4403 18.5 10.0625 18.1222 10.0625 17.6562V15.9687M11.75 5L6.6875 5C5.75552 5 5 5.75552 5 6.6875L5 11.75C5 12.682 5.75552 13.4375 6.6875 13.4375L11.75 13.4375C12.682 13.4375 13.4375 12.682 13.4375 11.75L13.4375 6.6875C13.4375 5.75552 12.682 5 11.75 5Z" />
  </>,
  "CopyRightOutlineIcon"
);
